var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-icon',{staticClass:"MoveHandle",class:{ 'elevation-2': hover },attrs:{"data-test":"dragHandle","small":"","color":"primary"}},[_vm._v(" mdi-arrow-up-down ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }